var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Temblores PR")]),_c('router-view'),_c('h4',{staticStyle:{"margin-top":"50px"}},[_vm._v("Created By Lesther Ruiz")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }